var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('Header'),_c('PartnerComp'),_c('PersonalityNew'),_c('Mission'),_c('Services'),_c('Advisors'),_c('Location'),_c('GetInTouch'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }